import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import {Button, Modal, ModalBody, ModalFooter} from 'reactstrap';
import UploadFile from '../includes/UploadFile';
import AutoComplete from '../includes/AutoComplete';
import * as vignetsActions from "../../actions/vignets";
import {withRouter} from 'react-router';
import * as uploadActions from "../../actions/upload";
import * as playlistActions from "../../actions/playlist";
import AuthService from '../../lib/AuthService';
import { WithContext as ReactTags } from 'react-tag-input';
const KeyCodes = {
    comma: 188,
    enter: 13,
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];
class NewItemAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            vname_class : '',
            vtags_class : '',
            vignet_name: '',
            vignet_tags: '',
            vignet_desc :'',
            titleError  : '',
            modal: false,
            redirect: false,
            builderState : false,
            builderUrl : '',
            image_path: null,
            selectedProjects: []

        };
        this.Auth = new AuthService();
        this.toggle = this.toggle.bind(this);
        this.savingItems = this.savingItems.bind(this);

    }
    componentDidMount() {
        this.setState({modal : this.props.vignetsData.modalOpen});

    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.vignetsData.modalOpen !== prevProps.vignetsData.modalOpen) {
            this.setState({modal : this.props.vignetsData.modalOpen});
        }
    }

    toggle() {
        this.setState({
            modal: !this.state.modal,
            image_path: null,
            vignet_name : '',
            vignet_desc : '',
            vignet_tag : '',
            titleError : '',

        });
        this.props.uploadErrors({'error' : '', fileType : ''});
        this.props.modalToggle({modalOpen : !this.state.modal, modalTitle : "", "modalType" : ""});
    }
    savingItems(){
        this.props.saveItems();
        this.toggle();
    }
    render() {
        return (

            <Modal isOpen={this.state.modal} toggle={this.toggle} centered={true} className="vig-mod vig-modal user-md create-new-pop" id="vignetModal-user" tabindex="-1" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div className="modal-header">
                    <form id="company">
                        <button type="button" className="modal-btn-close" data-dismiss="modal" aria-label="Close" onClick={this.toggle} >✕</button>
                        <h4 className="modal-title">{this.props.vignetsData.modalTitle}</h4>
                    </form>
                </div>

                <ModalBody>
                    <div className="modal-content-wrapper small-modal">
                            <ReactTags
                                       tags={this.props.dataList }
                                       handleDelete={this.props.handleDelete}
                                       handleDrag={this.props.handleDrag}
                                       handleInputChange ={this.props.handleInputChange}
                                       delimiters={delimiters}
                                       placeholder={this.props.placeholder}/>

                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={this.toggle}>Cancel</Button>
                    <Button color="primary" onClick={this.savingItems} >{this.props.buttonStatus}</Button>
                </ModalFooter>

            </Modal>
        );
    }
}

NewItemAdd.propTypes = {
    completed: PropTypes.number,
    title : PropTypes.string
}

function mapStateToProps(state) {
    return {
        uploadData : state.upload.uploadData,
        vignetsData : state.vignets.vignetsData,
        selectedItems : state.vignets.getSelectedItems
    };
}

export default  withRouter(connect(mapStateToProps, {
    createVignet : vignetsActions.createVignet,
    uploadErrors: uploadActions.uploadErrors,
    getImagepurged : playlistActions.purgeImage,
    modalToggle : vignetsActions.toggleModal,
    joinVignets : vignetsActions.joinVignets,
    setSelectedItems : vignetsActions.setSelectedItems
})(NewItemAdd));



// WEBPACK FOOTER //
// ./src/components/vignets/NewItemAdd.js